import React from "react";

const PropertyFeatures = ({
  title,
  icon,
  items,
}: {
  title: string;
  icon: string;
  items: string[];
}) => (
  <ul className="p-0">
    <div className="flex items-center mb-3 gap-2">
      <img src={icon} alt={`${title} icon`} />
      <h6>{title}</h6>
    </div>
    <div className="mt-4">
      {items.map((item, idx) => (
        <li key={idx} className="my-3">
          <p className="flex align-items-center gap-1">
            <i className="fa fa-check fa-md p-1 text-white bg-primary rounded-full fa-solid"></i>
            &nbsp;
            <span className="capitalize fs-16">{item}</span>
          </p>
        </li>
      ))}
    </div>
  </ul>
);

export default PropertyFeatures;
